import { render } from "./Approvals.vue?vue&type=template&id=06e26daf&scoped=true"
import script from "./Approvals.vue?vue&type=script&lang=js"
export * from "./Approvals.vue?vue&type=script&lang=js"

import "./Approvals.vue?vue&type=style&index=0&id=06e26daf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e26daf"]])

export default __exports__